import { useState } from "react";
import { feedItems, hotRank, latestUpdates } from "@/mocks/home";

const sortOptions = ["最新整理", "热度优先", "合集优先"];

export default function FeedSection() {
  const [sort, setSort] = useState(sortOptions[0]);

  return (
    <section
      id="feed"
      className="w-full border-y border-background-200/70 bg-background-100 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-article-line"></i>
              </span>
              LATEST FEED
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              最新整理
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              持续更新黑料全集，图文一并整理，按话题归档。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200/80 bg-background-50 p-1">
            {sortOptions.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => setSort(option)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                  sort === option
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
              {feedItems.map((item, index) => (
                <a
                  key={item.id}
                  href="#packs"
                  className={`group flex cursor-pointer gap-4 p-4 transition-colors hover:bg-background-100 md:p-5 ${
                    index !== feedItems.length - 1
                      ? "border-b border-background-200/70"
                      : ""
                  }`}
                >
                  <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md md:h-28 md:w-44">
                    <img
                      src={item.image}
                      alt={`${item.title} - 爆料黑料合集图文整理`}
                      title={`${item.title} - 黑料汇总整理`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-medium text-primary-800">
                        {item.category}
                      </span>
                      <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {item.excerpt}
                    </p>
                    <div className="mt-auto flex items-center gap-4 pt-3 text-[11px] text-foreground-500">
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-time-line"></i>
                        </span>
                        {item.time}
                      </span>
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-fire-line"></i>
                        </span>
                        {item.heat}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            <a
              href="#collections"
              className="mt-4 flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-background-200/80 bg-background-50 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看全部 218 条整理
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>

          <aside className="flex flex-col gap-4 lg:col-span-4">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <span className="flex h-5 w-5 items-center justify-center text-accent-600">
                    <i className="ri-fire-fill"></i>
                  </span>
                  热度榜
                </h3>
                <span className="text-[11px] text-foreground-500">实时</span>
              </div>
              <ol className="mt-4 flex flex-col">
                {hotRank.map((item) => (
                  <li key={item.rank}>
                    <a
                      href="#feed"
                      className="group flex cursor-pointer items-center gap-3 border-b border-background-200/60 py-2.5 last:border-b-0"
                    >
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                          item.rank <= 3
                            ? "bg-accent-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="line-clamp-1 flex-1 text-sm text-foreground-800 transition-colors group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="shrink-0 text-[11px] text-foreground-500">
                        {item.heat}
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-history-line"></i>
                </span>
                更新日志
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {latestUpdates.map((item) => (
                  <li key={item.title} className="flex gap-3">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-400"></span>
                    <div className="min-w-0">
                      <p className="text-sm leading-snug text-foreground-800">
                        {item.title}
                      </p>
                      <span className="text-[11px] text-foreground-500">
                        {item.time}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <a
              href="#packs"
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-primary-200 bg-primary-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-inbox-archive-line text-lg"></i>
              </span>
              <span className="min-w-0">
                <span className="block font-heading text-sm font-bold text-foreground-950">
                  黑料打包专区
                </span>
                <span className="mt-0.5 block text-xs text-foreground-600">
                  57 份整理包 · 支持按话题订阅
                </span>
              </span>
              <span className="ml-auto flex h-5 w-5 shrink-0 items-center justify-center text-primary-600 transition-transform group-hover:translate-x-0.5">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}